import React from 'react';
import PropTypes from 'prop-types';
import styles from './ListeMotif.module.scss';
import { ReactComponent as Check } from '../../../../../../assets/compte/check-shadow.svg';

const ListeMotif = ({ motifs, register, motifsSelectionnes }) => {
    return (
        <div className={styles.ListeMotifs}>
            {motifs.map((motif) => {
                const isSelectionne = motifsSelectionnes[motif.id];

                let isDisabled = false;
                if (motif.inactif) {
                    isDisabled = true;
                } else {
                    Object.entries(motifsSelectionnes).forEach((motifSelectionne) => {
                        if (motifSelectionne[1] && motif.disable.includes(motifSelectionne[0])) {
                            isDisabled = true;
                        }
                    });
                }

                let labelClass = styles['ListeMotifs-Motif'];

                if (isDisabled) {
                    labelClass += ` ${styles.disabled}`;
                }
                if (isSelectionne) {
                    labelClass += ` ${styles.selectionne}`;
                }

                return (
                    <div>
                        <label htmlFor={`motif.${motif.id}`} key={motif.nom} className={labelClass}>
                            <div
                                className={`${styles['ListeMotifs-Background']} ${
                                    styles[motif.id]
                                }`}
                            />
                            <input
                                {...register(`motif.${motif.id}`)}
                                type="checkbox"
                                id={`motif.${motif.id}`}
                                name={`motif.${motif.id}`}
                                disabled={isDisabled}
                                title={`Motif : ${
                                    motif.nom
                                        ? motif.nom
                                        : motif.nomPlusieursLignes
                                              .map((ligne) => {
                                                  return `${ligne}`;
                                              })
                                              .join(', ')
                                }`}
                            />
                            <motif.iconeComponent className={styles['ListeMotifs-Image']} />
                            {isSelectionne && <Check className={styles['ListeMotifs-Check']} />}
                        </label>
                        {motif.nom && (
                            <div className={styles['ListeMotifs-Titre']}>{motif.nom}</div>
                        )}
                        {motif.nomPlusieursLignes && (
                            <div className={styles['ListeMotifs-Titre']}>
                                {motif.nomPlusieursLignes.map((ligne, index) => {
                                    return (
                                        <>
                                            {index !== 0 && <br />}
                                            {ligne}{' '}
                                        </>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

ListeMotif.propTypes = {
    motifs: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            nom: PropTypes.string,
            nomPlusieursLignes: PropTypes.arrayOf(PropTypes.string),
            iconeComponent: PropTypes.element.isRequired,
            disable: PropTypes.arrayOf(PropTypes.string).isRequired,
            inactif: PropTypes.bool,
        }).isRequired,
    ).isRequired,
    motifsSelectionnes: PropTypes.shape({
        isChasseur: PropTypes.bool,
        isLicencie: PropTypes.bool,
        isCollectionneur: PropTypes.bool,
        isNonLicencie: PropTypes.bool,
        isDetenteurProfessionnel: PropTypes.bool,
    }),
    register: PropTypes.func.isRequired,
};

export default ListeMotif;
